import { LogEntryResponse } from 'mapistry-shared';

export type LogEntry = Omit<
  LogEntryResponse,
  'createdBy' | 'updatedBy' | 'createdAt' | 'updatedAt'
>;

export const LOG_DATE_FIELD_NAME = 'logDate';
